'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ADMIN_NAV_LIST: 'adminNavList',
  APP_NAV_LIST: 'appNavList',
  IDENTITY_ID_COOKIE: 'identityId',
  IMPERSONATE_IDENTITY_ID: 'identityID',
  IS_ADMIN_COOKIE: 'isAdmin',
  IS_PROVIDER_ADMIN_COOKIE: 'isProviderAdmin',
  LD_CLIENT_SIDE_ID: 'LD_CLIENT_SIDE_ID',
  PLATFORM_CONFIG: 'platformConfig',
  TEMP_USER_BRAND_COOKIE: 'tempUserBrand',
  TEMP_USER_EMAIL_COOKIE: 'tempUserEmail',
  TEMP_USER_FIRST_NAME_COOKIE: 'tempUserFirstName',
  TEMP_USER_INVITOR_COOKIE: 'tempUserInvitor',
  TEMP_USER_LAST_NAME_COOKIE: 'tempUserLastName',
  TEMP_USER_TYPE_COOKIE: 'tempUserType',
  TOKEN_COOKIE: 'authToken',
  USER_COMPANY_COOKIE: 'userCompany',
  USER_CREATE_DATE_COOKIE: 'dateCreated',
  USER_CURRENCY_COOKIE: 'defaultCurrency',
  USER_EMAIL_COOKIE: 'email',
  USER_IDENTITY_ID_COOKIE: 'identityId',
  USER_IMPERSONATING_COOKIE: 'impersonating',
  USER_NAME_COOKIE: 'displayName',
  USER_NAV_LIST: 'userNavList',
  USER_TIMEZONE_COOKIE: 'defaultTimezone',
  USER_TITLE_COOKIE: 'title',
  USER_TITLE_TYPE_COOKIE: 'titleType'
};
//# sourceMappingURL=User-constants.js.map